export default Object.freeze({
  DAILYTIMEDURATION: {
    milliseconds: 1000, // milliseconds in a second
    seconds: 60, // seconds in a minute
    minutes: 60, // minutes in an hour
    hours: 24 // hours in a day
  }
});

export const womenCompetitionCodes: string[] = ['FB-EUR-WEUROS', 'FB-WOR-WWORLDCUP'];
